import { render, staticRenderFns } from "./EquipmentOnHoldSelector.vue?vue&type=template&id=884cffa2"
import script from "./EquipmentOnHoldSelector.vue?vue&type=script&lang=js"
export * from "./EquipmentOnHoldSelector.vue?vue&type=script&lang=js"
import style0 from "./EquipmentOnHoldSelector.vue?vue&type=style&index=0&id=884cffa2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports